module.exports = __webpack_public_path__ + "static/media/landing-feature-followup.468eab86.svg";